import httpClient from './httpClient';

const getRoomTypeAvailability = (model) => httpClient.post('/api/v2/Booking/GetRoomTypeAvailability', model);

const getRoomTypeAvailabilityRoomAndBed = (model) => httpClient.post('/api/v2/Booking/GetRoomTypeAvailabilityRoomAndBed', model);

const checkAvailableRoom = (model) => httpClient.post('/api/v2/Booking/CheckAvailableRoom', model);

const getBookingDetails = (bookingId, propertyId) => httpClient.get('/api/v2/Booking/GetBookingDetails', { params: { bookingId, propertyId } });

const getRoomStays = (bookingId) => httpClient.get('/api/v2/Booking/GetRoomStays', { params: { bookingId } });

const getRoomStaysByBVOrder = (bookingId) => httpClient.get('/api/v2/Booking/GetRoomStaysByBVOrder', { params: { bookingId } });

const getRoomStay = (roomStayId) => httpClient.get('/api/v2/Booking/GetRoomStay', { params: { roomStayId } });

const getRoomStaysTotalGuest = (bookingId) => httpClient.get('/api/v2/Booking/GetRoomStayTotalGuest', { params: { bookingId } });

const getActivityLogs = (bookingId) => httpClient.get('/api/v2/Booking/GetActivityLogs', { params: { bookingId } });

const getBookingNotes = (bookingId) => httpClient.get('/api/v2/Booking/GetBookingNotes', { params: { bookingId } });

const getTransactionList = (bookingId, ShowTransfer) => httpClient.get('/api/v2/Booking/GetTransactionList', { params: { bookingId, ShowTransfer } });

const getStatementOfAccountItemList = (bookingId, roomTransactionId ,ShowTransfer) => httpClient.get('/api/v2/Booking/GetStatementOfAccountItemList', { params: { bookingId, roomTransactionId, ShowTransfer } });

const getNewStatementOfAccountItemList = (bookingId, roomTransactionId, ShowTransfer) => httpClient.get('/api/v2/Booking/GetNewStatementOfAccountItemList', { params: { bookingId, roomTransactionId, ShowTransfer } });

const getBookingSummary = (bookingId, propertyId) => httpClient.get('/api/v2/Booking/GetBookingSummary', { params: { bookingId, propertyId } });

const getDeallocatedRooms = (propertyId) => httpClient.get('/api/v2/Booking/GetDeallocatedRooms', { params: { propertyId } });

const getBookingCancelled = (propertyId) => httpClient.get('/api/v2/Booking/GetBookingCancelled', { params: { propertyId } });

const getRoomStayGuest = (roomTransactionId) => httpClient.get('/api/v2/Booking/GetRoomStayGuest', { params: { roomTransactionId } });

const getRoomStayGuestByBookingId = (bookingId) => httpClient.get('/api/v2/Booking/GetRoomStayGuestByBookingId', { params: { bookingId } });

const addRoomStayGuest = (model, bookingId, userId,isPMSUsing) => httpClient.post('/api/v2/Booking/AddRoomStayGuest', model, { params: { bookingId, userId ,isPMSUsing} });

const updateBookingStatus = (model) => httpClient.post('/api/v2/Booking/UpdateBookingStatus', model);

const updateArrivalTime = (model) => httpClient.post('/api/v2/Booking/UpdateArrivalTime', model);

const deallocateRoom = (roomStayId, userId) => httpClient.post('/api/v2/Booking/DeallocateRoom', {}, { params: { roomStayId, userId } });

const removeRoomStayGuest = (model, bookingId, userId) => httpClient.post('/api/v2/Booking/RemoveRoomStayGuest', model, { params: { bookingId, userId } });

const assignMainGuest = (model, bookingId, userId) => httpClient.post('/api/v2/Booking/AssignMainGuest', model, { params: { bookingId, userId } });

const lockUnLockBooking = (bookingId, isLocked, userId) => httpClient.post('/api/v2/Booking/LockUnLockBooking', {}, { params: { bookingId, isLocked, userId } });

const deleteRoomStay = (roomStayId, userId) => httpClient.post('/api/v2/Booking/DeleteRoomStay', {}, { params: { roomStayId, userId } });

const createBooking = (model) => httpClient.post('/api/v2/Booking/CreateBooking', model);

const addRoom = (model) => httpClient.post('/api/v2/Booking/AddRoom', model);

const addBookingNote = (model) => httpClient.post('/api/v2/Booking/AddNote', model);

const bookingSummary = (model) => httpClient.post('/api/v2/Booking/BookingSummary', model);

const createReservationBookingSummary = (model) => httpClient.post('/api/v2/Booking/CreateReservationBookingSummary', model);

const searchBooking = (model) => httpClient.post('/api/v2/Booking/SearchBooking', model, { timeout: 180000 });

const updateRoomStayArrival = (model) => httpClient.post('/api/v2/Booking/UpdateRoomStayArrival', model);

const changeRoom = (model) => httpClient.post('/api/v2/Booking/ChangeRoom', model);

const autoAllocateRoom = (model) => httpClient.post('/api/v2/Booking/AutoAllocateRoom', model);

const splitRoom = (model) => httpClient.post('/api/v2/Booking/SplitRoom', model);

const getTransactionListByBookingTypeValue = (bookingType, bookingTypeValue, filterStart, filterEnd) => httpClient.get('/api/v2/Booking/GetTransactionListByBookingTypeValue', { params: { bookingType, bookingTypeValue, filterStart, filterEnd } });

const updateRoomStayStatus = (model) => httpClient.post('/api/v2/Booking/UpdateRoomStayStatus', model, { timeout: 180000 });

const checkCheckInPreviousDate = (model) => httpClient.post('/api/v2/Booking/CheckCheckInPreviousDate', model);

const getModifiedReservation = (bookingId) => httpClient.get('/api/v2/Booking/GetModifiedReservation', { params: { bookingId } });

const autoUpdateReservation = (bookingId) => httpClient.post('/api/v2/Booking/AutoUpdateReservation', {}, { params: { bookingId } });

const getEmailReceiverByBookingId = (bookingId) => httpClient.get('/api/v2/Booking/GetEmailReceiverByBookingId', { params: { bookingId } })

const getBookingIdByOrderCode = (orderCode) => httpClient.get('/api/v2/Booking/GetBookingIdByOrderCode', { params: { orderCode } })


const resetBookingModifiedStatus = (bookingId) => httpClient.post('/api/v2/Booking/ResetBookingModifiedStatus', {}, { params: { bookingId } });

const markBookingNotificationReaded = (bookingId) => httpClient.post('/api/v2/Booking/MarkBookingNotificationReaded', {}, { params: { bookingId } });

const updateHoldTillDate = (model) => httpClient.post('/api/v2/Booking/UpdateHoldTillDate', model);

const addGeneralNote = (model) => httpClient.post('/api/v2/Booking/AddGeneralNote', model);

const updateGeneralNote = (model) => httpClient.post('/api/v2/Booking/UpdateGeneralNote', model);

const softDeleteGeneralNote = (bookingGeneralNoteId) => httpClient.post('/api/v2/Booking/SoftDeleteGeneralNote', {}, { params: { bookingGeneralNoteId } });

const getBookingGeneralNotes = (bookingId) => httpClient.get('/api/v2/Booking/GetBookingGeneralNotes', { params: { bookingId } });

const getAddOnsNote = (bookingId) => httpClient.get('/api/v2/Booking/GetAddOnsNote', { params: { bookingId } });

/**
 * Consolidated page-load endpoint.
 * Returns booking, roomStays, bookingNotes, generalNotes, addOnsNote,
 * totalGuest and statementOfAccount in a single HTTP round-trip.
 */
const getReservationPageData = (bookingId, propertyId, showTransfer = false) =>
  httpClient.get('/api/v2/Booking/GetReservationPageData', { params: { bookingId, propertyId, showTransfer } });

const updateRemarksAddOn = (model) => httpClient.post('/api/v2/Booking/UpdateRemarksAddOn', model);

const getRoomOccupiedByDate = (propertyId) => httpClient.get('/api/v2/Booking/GetRoomOccupiedByDate', { params: {propertyId } });


const getUnpaidBalanceByTransactionId = (bookingId, roomTransactionId, ShowTransfer) => httpClient.get('/api/v2/Booking/GetUnpaidBalanceByTransactionId', { params: { bookingId, roomTransactionId, ShowTransfer } });

const addRoomStayGuestPMS = (model, bookingId, userId, isPMSUsing) => httpClient.post('/api/v2/Booking/AddRoomStayGuestPMS', model, { params: { bookingId, userId, isPMSUsing } });

const ex = {
  resetBookingModifiedStatus,
  getRoomTypeAvailability,
  getRoomStayGuestByBookingId,
  getRoomTypeAvailabilityRoomAndBed,
  checkAvailableRoom,
  getDeallocatedRooms,
  getBookingSummary,
  getBookingCancelled,
  createBooking,
  addRoom,
  bookingSummary,
  getBookingDetails,
  getRoomStays,
  getRoomStay,
  getRoomStaysTotalGuest,
  deallocateRoom,
  updateRoomStayStatus,
  updateRoomStayArrival,
  updateBookingStatus,
  updateArrivalTime,
  deleteRoomStay,
  searchBooking,
  getActivityLogs,
  getBookingNotes,
  addBookingNote,
  getRoomStayGuest,
  addRoomStayGuest,
  removeRoomStayGuest,
  assignMainGuest,
  getTransactionList,
  lockUnLockBooking,
  changeRoom,
  splitRoom,
  getTransactionListByBookingTypeValue,
  checkCheckInPreviousDate,
  getModifiedReservation,
  autoUpdateReservation,
  getEmailReceiverByBookingId,
  markBookingNotificationReaded,
  getBookingIdByOrderCode,
  updateHoldTillDate,
  getStatementOfAccountItemList,
  getNewStatementOfAccountItemList,
  createReservationBookingSummary,
  autoAllocateRoom,
  addRoomStayGuestPMS,
  addGeneralNote,
  updateGeneralNote,
  softDeleteGeneralNote,
  getBookingGeneralNotes,
  getAddOnsNote,
  updateRemarksAddOn,
  getUnpaidBalanceByTransactionId,
  getRoomStaysByBVOrder,
  getRoomOccupiedByDate,
  getReservationPageData
}

export default ex;



// WEBPACK FOOTER //
// ./src/api/booking-api.js